module.exports = __webpack_public_path__ + "img/icon-global.b1a17901.svg";